/* eslint-disable */
export default {
	NODE_ENV: 'development',
	API_URL: 'http://localhost:8083/api',
	AUTH_URL: 'http://localhost:8083/api/auth/login',
	LR_CLOUD_URL: 'http://localhost:8081'
}
/* eslint-enable */
